import DashboardIncidentsMainBranches from './DashboardIncidentsMainBranches';

export default DashboardIncidentsMainBranches;
